import React, { Fragment, useState, useEffect } from "react";
import timeZoneList from "../../../../../data/timeZoneList";
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import 'rc-switch/assets/index.css';
import { CardBody, Button, Card, CustomInput, Input, Label,Row,ButtonGroup } from "reactstrap";
import grid_layout from '../images/grid_layout.png';
import collage_layout from '../images/collage_layout.png';
import masoonary_layout from '../images/masoonary_layout.png';
import column_layout from '../images/column_layout.png';
import pro_layout from '../images/pro_layout_image.png';
import slideshow_layout from '../images/slideshow_layout.png';
import slider_layout from '../images/slider_layout.png';
import thumbnail_layout from '../images/thumbnail_layout.png';
import paranoma_layout from '../images/paranoma_layout.png';
import { Colxx, Separator } from "../../../../../components/common/CustomBootstrap";
import standalone_languages from "./StandalonePage/StandaloneLanguages";
import StandaloneCurrency from "./StandalonePage/StandaloneCurrency";
const StandaloneFeatures = ({ pageSettings, saveIntegration, country, }) => {       
    const [timeZone, setTimeZone] = useState([]);    
    const [layout, setLayout] = useState(pageSettings !== undefined && pageSettings !== null
        &&
        pageSettings );
    const [features,setFeatures]=useState((pageSettings!== undefined && pageSettings.features)?pageSettings.features: {
        manageCurrency:false,
        selectedCurrency: [],
        manageRedeem:false,        
        manageGiftCard:false,
        manageLanguages:false,
        selectedLanguages:[],
        giftCardTopUp:false,
        defaultCurrency:'',
        defaultLanguage:''
    });
    const [languageGPT3, setLanguageGPT3] = useState([]);
    const [currencyList,setCurrencyList]=useState([]);

    useEffect(() => {
        const languageList = standalone_languages.map((elem) => {
            elem.checked = false;
            if (pageSettings!== undefined && pageSettings.features !== undefined) {
                pageSettings.features.selectedLanguages.forEach((lang) => {
                    if (lang === elem.code) {
                        elem.checked = true;
                    }
                });
            }
            return elem;
        });
        const currencies = StandaloneCurrency.map((elem) => {
            elem.checked = false;
            if (pageSettings!== undefined && pageSettings.features !== undefined) {
                pageSettings.features.selectedCurrency.forEach((lang) => {
                    if (lang === elem.code) {
                        elem.checked = true;
                    }
                });
            }
            return elem;
        });


        setLanguageGPT3(languageList);
        setCurrencyList(currencies);
    }, [pageSettings]);

    const handleSave = () => {      
        pageSettings.features = features;
        saveIntegration({ pageSettings: pageSettings });
    }; 

    const handleLanguageChange = (e) => {
        const values = languageGPT3.map((elem) => {
            if (elem.code === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setLanguageGPT3(values);
        const langArr = values.filter((elem) => elem.checked === true).map((elem) => elem.code);
        setFeatures({ ...features, selectedLanguages: langArr });
    };
    const handleCurrencyChange = (e) => {
        const values = currencyList.map((elem) => {
            if (elem.code === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setCurrencyList(values);
        const currencyArr = values.filter((elem) => elem.checked === true).map((elem) => elem.code);
        setFeatures({ ...features, selectedCurrency: currencyArr });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody className="mb-2">
                    <div className="col-md-12 my-2"> 
                      <div className="mb-1 ml-2 d-flex">
                                <h4>Redeem</h4>                            
                                <div className="ml-2">
                                    <Switch
                                        className="custom-switch custom-switch-primary custom-switch-small "
                                        checked={features.manageRedeem}
                                        onChange={(primary) => setFeatures({...features,manageRedeem:primary})}
                                    />
                                </div>
                            </div>                                                   
                        </div>
                    <Separator className="mb-3" />
                    <div className="col-md-12 my-2"> 
                      <div className="mb-1 d-flex">                                                           
                            <div className="ml-2 d-flex">
                                <h4>Manage Gift Card</h4>
                                <Switch
                                    className="custom-switch custom-switch-primary custom-switch-small  ml-2"
                                    checked={features.manageGiftCard}
                                    onChange={(primary) => setFeatures({ ...features, manageGiftCard: primary })}
                                />
                            </div>
                            <div className="ml-3 d-flex">
                                <h4>Gift Card Top Up</h4>
                                <Switch
                                    className="custom-switch custom-switch-primary custom-switch-small ml-2"
                                    checked={features.giftCardTopUp}
                                    onChange={(primary) => setFeatures({ ...features, giftCardTopUp: primary })}
                                />
                            </div>
                                
                            </div>                                                   
                        </div>
                    <Separator className="mb-3" />
                    <div className=" row ml-2">                 
                    <div className="col-md-12 my-2"> 
                            <div className="mb-1 d-flex">
                                <h4>Multi Currency</h4>                                
                                <div className="ml-2">
                                    <Switch
                                        className="custom-switch custom-switch-primary custom-switch-small "
                                        checked={features.manageCurrency}
                                        onChange={(primary) => setFeatures({...features,manageCurrency:primary})}
                                    />
                                </div>
                            </div>
                            {features.manageCurrency && (
                                <Fragment>
                                    <div className="mb-1 ml-2 text-center">
                                        <b>Default Currency</b>
                                        <br />
                                        <div className="d-flex justify-content-center mb-2 mt-2">
                                            <Input
                                                type="select"  
                                                style={{width:'50%'}}  
                                                value={features.defaultCurrency}
                                                name="type"
                                                onChange={(e)=>setFeatures({...features,defaultCurrency :e.target.value})}
                                            >
                                                {currencyList.map((elem, index) => (
                                                    <option value={elem.code}>{elem.name}</option>
                                                ))}
                                            </Input>

                                        </div>

                                    </div>
                                </Fragment>
                            )}
                            {features.manageCurrency && (
                                <Fragment>                                    
                                    <div className="mb-1 ml-2 text-center">
                                        <b>Choose Currency</b>
                                        <br />
                                        <Row className="mt-2">
                                            {currencyList.map((elem, index) => (
                                                <Colxx xxs="6">
                                                    {' '}
                                                    <CustomInput
                                                        key={index}
                                                        type="checkbox"
                                                        value={elem.code}
                                                        id={elem.code}
                                                        onChange={handleCurrencyChange}
                                                        checked={elem.checked}
                                                        className="text-left"
                                                    >
                                                        {elem.name}({elem.code})
                                                    </CustomInput>
                                                </Colxx>
                                            ))}
                                        </Row>
                                    </div>
                                </Fragment>)}                        
                        </div>
                        
                        <Separator className="mb-3" />
                        <div className="col-md-12 my-2">                         
                        <div className="mb-1 d-flex">
                                <h4>Multi Languages</h4>                                
                                <div className="ml-2">
                                    <Switch
                                        className="custom-switch custom-switch-primary custom-switch-small "
                                        checked={features.manageLanguages}
                                        onChange={(primary) => setFeatures({...features,manageLanguages:primary})}
                                    />
                                </div>
                            </div>
                            {features.manageLanguages && (
                                <Fragment>
                                    <div className="mb-1 ml-2 text-center">
                                        <b>Default Language</b>
                                        <br />
                                        <div className="d-flex justify-content-center mb-2 mt-2">
                                            <Input
                                                type="select"  
                                                style={{width:'50%'}}                                               
                                                value={features.defaultLanguage}
                                                name="type"
                                                onChange={(e)=>setFeatures({...features,defaultLanguage :e.target.value})}
                                            >
                                                {languageGPT3.map((elem, index) => (
                                                    <option value={elem.code}>{elem.name}</option>
                                                ))}
                                            </Input>

                                        </div>

                                    </div>
                                </Fragment>
                            )}
                            {features.manageLanguages && (
                                <Fragment>                                    
                                    <div className="mb-1 ml-2 text-center">
                                        <b>Choose Languages</b>
                                        <br />
                                        <Row className="mt-2">
                                            {languageGPT3.map((elem, index) => (
                                                <Colxx xxs="4">
                                                    {' '}
                                                    <CustomInput
                                                        key={index}
                                                        type="checkbox"
                                                        value={elem.code}
                                                        id={elem.code}
                                                        onChange={handleLanguageChange}
                                                        checked={elem.checked}
                                                        className="text-left"
                                                    >
                                                        {elem.name}
                                                    </CustomInput>
                                                </Colxx>
                                            ))}
                                        </Row>
                                       
                                    </div>
                                </Fragment>
                            )}
                        </div>                                                      
                        
                    </div>
                    <div className="text-center mt-4 mb-3">
                    <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                            <Button color="primary" size="xs" outline onClick={handleSave}>
                                                Save
                                            </Button>
                                        </ButtonGroup>                  
                    </div>
                </CardBody>
            </Card >
        </Fragment >
    );
}
export default StandaloneFeatures;
